export default "/images/ba43370455506f6c801620975f455a87.avif";